import { render, staticRenderFns } from "./PhoneAccountImport.vue?vue&type=template&id=667e9ef3&scoped=true"
import script from "./PhoneAccountImport.vue?vue&type=script&lang=js"
export * from "./PhoneAccountImport.vue?vue&type=script&lang=js"
import style0 from "./PhoneAccountImport.vue?vue&type=style&index=0&id=667e9ef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e9ef3",
  null
  
)

export default component.exports